import { render, staticRenderFns } from "./UploadTemplate.vue?vue&type=template&id=1dce51c6&"
import script from "./UploadTemplate.vue?vue&type=script&lang=js&"
export * from "./UploadTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports